import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/openly-o-purple.svg")